// extracted by mini-css-extract-plugin
export default {"linkActivityWrapper":"LinkActivityWrapper_linkActivityWrapper__gcHGv"};